import React from "react";
import LoadingIcon from "../../shared/LoadingIcon";
import {
  MdAccountBalance,
  MdAttachMoney,
  MdInsertChart,
  MdMonetizationOn,
  MdPeople,
  MdPeopleOutline,
} from "react-icons/md";
import { ErrorPage } from "../../shared/ErrorPage";
import { formatCurrency } from "../../utils/Utils";
import SquareDashboardCard from "./square-dashboard-card/SquareDashboardCard";
import DashboardTable from "./dashboard-table/DashboardTable";
import FetchState from "../../api/FetchState";
import { useFetchDashboardData } from "./hooks";
import {DashboardCardRow} from "./DashboardStyles"

export default function Dashboard() {
  const [data, fetchState] = useFetchDashboardData();

  if (FetchState.SUCCESS === fetchState) {
    return (
      <>
        <DashboardCardRow>
          <SquareDashboardCard
            heading="Bank Balance"
            amount={
              "R " + formatCurrency(parseFloat(data.bankBalance).toFixed(2))
            }
            colour="c1"
            icon=<MdAccountBalance size={60} color="var(--c1)" />
          />

          <SquareDashboardCard
            heading="Cash Float"
            amount={
              "R " + formatCurrency(parseFloat(data.cashOnHand).toFixed(2))
            }
            colour="c7"
            icon=<MdAttachMoney size={60} color=" var(--c7)" />
          />

          <SquareDashboardCard
            heading="Investments"
            amount={
              "R " + formatCurrency(parseFloat(data.investments).toFixed(2))
            }
            colour="c4"
            icon=<MdInsertChart size={60} color="var(--c4)" />
          />

          <SquareDashboardCard
            heading="Scheme Balance"
            amount={
              "R " + formatCurrency(parseFloat(data.schemeBalance).toFixed(2))
            }
            colour="c3"
            icon=<MdMonetizationOn size={60} color="var(--c3)" />
          />
        </DashboardCardRow>

        <DashboardCardRow>
          <SquareDashboardCard
            heading="Members"
            amount={data.members}
            colour="c5"
            icon=<MdPeople size={60} color="var(--c5)" />
          />

          <SquareDashboardCard
            heading="Dependants"
            amount={data.dependants}
            colour="c6"
            icon=<MdPeopleOutline size={60} color="var(--c6)" />
          />

          <DashboardTable
            premiums={data.premiums}
            claims={data.claims}
            incomes={data.incomes}
            expenses={data.expenses}
          />
        </DashboardCardRow>
      </>
    );
  } else if (FetchState.ERROR === fetchState) return <ErrorPage />;
  else if (FetchState.LOADING === fetchState) return <LoadingIcon />;
}
